// extracted by mini-css-extract-plugin
module.exports = {"discord":"discord--jlzxW","avatar":"avatar--3ck7L","account":"account--3nRTE"};